
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class OxygenControlName extends Vue {
  @Prop({ default: false })
  filled!: boolean;
}
